<div class="empty-list" *ngIf="text">
  {{ text | translate }}
</div>
